import React from "react";
import '../styles/component/data-loading.scss'

export interface ILoadingDataProps {
    title: string;
}

const DataLoading = (props: ILoadingDataProps) => {
    return (
        <div className="data-loading">
            <div className="data-loading__card">
                <div className="data-loading__spinner"/>

                <h3 className="data-loading__title">Fetching {props.title}...</h3>

                {/*<p className="data-loading__message">*/}
                {/*    Fetching {props.title}...*/}
                {/*</p>*/}
            </div>
        </div>
    )
}

export default DataLoading;